var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    _vm._l(_vm.tagArr, function (tag, index) {
      return _c(
        "span",
        { key: "tag_" + index },
        [
          _vm.prop !== undefined && _vm.type === "tag"
            ? _c(
                "el-tag",
                {
                  attrs: { type: tag.tagtype, size: "mini" },
                  on: { click: _vm.doclick },
                },
                [_vm._v(_vm._s(tag.title))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "text"
            ? _c(
                "span",
                { style: tag.tagcolor === "" ? {} : { color: tag.tagcolor } },
                [_vm._v(_vm._s(tag.title))]
              )
            : _vm._e(),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }